import {
  SET_THEME,
  SET_LANGUAGE,
  SET_LOCATION,
  SET_LOADING,
} from '../reducers/uiReducer';

// Action creators
export const setTheme = (theme) => ({
  type: SET_THEME,
  payload: theme,
});

export const setLanguage = (language) => ({
  type: SET_LANGUAGE,
  payload: language,
});

export const setLocation = (location) => ({
  type: SET_LOCATION,
  payload: location,
});

export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading,
});

// Thunk action to detect and set user's location
export const detectUserLocation = () => {
  return (dispatch) => {
    if (navigator.geolocation) {
      dispatch(setLoading(true));
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const location = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          dispatch(setLocation(location));
          dispatch(setLoading(false));
        },
        (error) => {
          console.error('Error getting location:', error);
          dispatch(setLoading(false));
          // Default to a fallback location (e.g., Sofia, Bulgaria)
          dispatch(setLocation({ lat: 42.6977, lng: 23.3219 }));
        },
        {
          enableHighAccuracy: false,
          timeout: 15000,
          maximumAge: 60000,
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
      // Default to a fallback location
      dispatch(setLocation({ lat: 42.6977, lng: 23.3219 }));
    }
  };
};

// Thunk action to initialize UI settings from localStorage
export const initializeUISettings = () => {
  return (dispatch) => {
    // Always use light theme
    dispatch(setTheme('light'));
    localStorage.setItem('theme', 'light');

    // Load language preference
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      dispatch(setLanguage(savedLanguage));
    } else {
      // Always default to English
      dispatch(setLanguage('en'));
      localStorage.setItem('language', 'en');
    }
  };
};
